import { linkFormSchema } from 'modules/Globalize/constants'
import { IMappedIsaacLink } from 'shared/interfaces/IIsaacLink'

export const globalizeProjectDetailsNavTabs = (projectFeedTotal: number, projectTourTotal: number, successTotal?: number) => [
  { label: 'Stories', value: 'stories', ...(projectFeedTotal > 0 && { count: projectFeedTotal }) },
  { label: 'Success Stories', value: 'successStories', count: successTotal },
  { label: 'Project Information', value: 'projectInfo' },
  { label: 'Localized Projects', value: 'localizedProjects' },
  { label: 'Tour', value: 'tour', count: projectTourTotal }
]

export const linkFormValidator = (links: IMappedIsaacLink[]) => {
  const validation: {
    [x: string]: any
  } = Object.create(linkFormSchema)
  if (links && links.length) {
    links.forEach((link, index) => {
      validation[`title-${link.key}`] = linkFormSchema.title
      validation[`link-${link.key}`] = linkFormSchema.link
    })
  }
  return validation
}
